module.exports = __webpack_public_path__ + "img/icon4.98d45eda.png";